import { z } from 'zod';

export const UuidV7Schema = z
  .string()
  .uuid('Must be a UUID (v7)')
  .describe('UUID v7, client-generated when the record is created offline');

export const PaginationSchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(20),
});

export type Pagination = z.infer<typeof PaginationSchema>;

export const PaginatedResponseSchema = <T extends z.ZodTypeAny>(item: T) =>
  z.object({
    items: z.array(item),
    total: z.number().int().min(0),
    page: z.number().int().min(1),
    pageSize: z.number().int().min(1),
  });

export const ErrorResponseSchema = z.object({
  statusCode: z.number().int(),
  message: z.string(),
  error: z.string().optional(),
  details: z.unknown().optional(),
});

export type ErrorResponse = z.infer<typeof ErrorResponseSchema>;

export const IsoDateStringSchema = z.string().datetime({ offset: true });

export const FrenchPostalCodeSchema = z
  .string()
  .regex(/^\d{5}$/, 'Code postal invalide (5 chiffres)');
